import React from 'react';
import WrappedBase from './WrappedBase';

import CartTrigger from '../containers/CartTrigger';

export default class CartTriggerWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <CartTrigger />
      </WrappedBase>
    );
  }
}
